import React,{useState} from 'react'
import { Link } from 'react-router-dom';

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'

import about from '../assets/images/accordion.jpg'


export default function AboutThree() {
    let [isOpen, setOpen] = useState(false);
  return (
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
                <div className="position-relative">
                    <img src={about} className="img-fluid shadow rounded" alt=""/>
                    <div className="play-icon">
                        <Link to="#" onClick={() => setOpen(true)} className="play-btn lightbox video-play-icon">
                            <i className="mdi mdi-play text-primary rounded-pill bg-white shadow"></i>
                        </Link>
                    </div>
                    <ModalVideo
                        channel="youtube"
                        youtube={{ mute: 0, autoplay: 0 }}
                        isOpen={isOpen}
                        videoId="yba7hPeTSjk"
                        onClose={() => setOpen(false)} 
                    />
                </div>
            </div>

            <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div className="section-title ms-md-4">
                    <h4 className="title mb-4">Who We Are ?</h4>
                    <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                    <Link to="/contact" className="btn btn-outline-primary mt-2"><i className="mdi mdi-phone"></i> Contact Us</Link>
                </div>
            </div>
        </div>
    </div>
  )
}
